import React from "react";
import clsx from "clsx";

export const getRegistrationFieldErrorId = (field) =>
  `registration-field-error-${field}`;

export const isRegistrationFieldInvalid = (
  errors,
  touched,
  submitCount,
  field
) => Boolean(errors?.[field] && (touched?.[field] || submitCount > 0));

const joinDescribedByIds = (...ids) =>
  ids.flat().filter(Boolean).join(" ") || undefined;

export const getRegistrationFieldControlProps = ({
  field,
  errors,
  touched,
  submitCount,
  className,
  describedBy,
  required = false,
  invalid: invalidOverride,
} = {}) => {
  const invalid =
    invalidOverride ??
    isRegistrationFieldInvalid(errors, touched, submitCount, field);
  const errorId = getRegistrationFieldErrorId(field);

  return {
    className: clsx(className, invalid && "form-input--invalid"),
    "aria-invalid": invalid || undefined,
    "aria-required": required || undefined,
    "aria-describedby": joinDescribedByIds(
      describedBy,
      invalid ? errorId : null
    ),
  };
};

export const focusFirstInvalidRegistrationField = (orderedFields, errors) => {
  if (typeof document === "undefined") {
    return false;
  }

  const match = orderedFields.find(({ field }) => Boolean(errors?.[field]));
  if (!match) {
    return false;
  }

  const node = match.selector
    ? document.querySelector(match.selector)
    : document.getElementById(match.id);

  if (!(node instanceof HTMLElement)) {
    return false;
  }

  node.focus();
  if (typeof node.scrollIntoView === "function") {
    node.scrollIntoView({ block: "nearest", inline: "nearest" });
  }
  return true;
};

export const RegistrationContinueArrow = () => (
  <span aria-hidden="true"> →</span>
);

export const RegistrationSelectedCheck = ({
  width = 10,
  height = 10,
  stroke = "currentColor",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    stroke={stroke}
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <polyline points="2 6 5 9 10 3" />
  </svg>
);

export const RegistrationFieldError = ({ id, children, style }) => {
  if (!children) {
    return null;
  }

  return (
    <div id={id} className="text-danger" style={style}>
      <span className="text-danger-icon" aria-hidden>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <circle
            cx="6"
            cy="6"
            r="5.25"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            d="M6 3.4v3.1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle cx="6" cy="8.45" r="0.7" fill="currentColor" />
        </svg>
      </span>
      <span>{children}</span>
    </div>
  );
};
